import type { Vec2 } from '../../utils/vec2.js';
import type { EntityId, PlayerId, Tick } from '../ids.js';

import type { CommandBase } from './Command.js';

export interface AttackMoveCommand extends CommandBase {
  kind: 'attack_move';
  squadIds: EntityId[];
  target: Vec2;
}

export function makeAttackMoveCommand(args: {
  issuedBy: PlayerId;
  tick: Tick;
  squadIds: EntityId[];
  target: Vec2;
}): AttackMoveCommand {
  return {
    kind: 'attack_move',
    issuedBy: args.issuedBy,
    tick: args.tick,
    squadIds: [...args.squadIds],
    target: { x: args.target.x, y: args.target.y },
  };
}
